<template>
  <form class="app-reviewable-form" :style="cssVars" @submit.prevent="onSubmit">
    <div class="form-inner">
      <textarea
        v-model.trim="text"
        ref="textarea"
        class="review-textarea"
        :minlength="3"
        :maxlength="1000"
        required
        placeholder="Start typing..."
      />
      <div v-if="closeable" class="btn-close-wrapper">
        <button class="btn-close" type="button" @click="onClose">
          <AppCrossIcon />
        </button>
      </div>
    </div>
    <div class="form-footer">
      <button class="btn-submit" :disabled="!text" type="submit">Send</button>
    </div>
  </form>
</template>

<script>
import AppCrossIcon from '@/components/icons/AppCrossIcon.vue';

export default {
  name: 'AppReviewableForm',
  components: { AppCrossIcon },

  props: {
    autofocus: {
      type: Boolean,
      default: false,
    },
    closeable: {
      type: Boolean,
      default: false,
    },
    textareaMinH: {
      type: Number,
      default: 132,
    },
  },

  data() {
    return {
      text: '',
    };
  },

  computed: {
    cssVars() {
      return {
        '--app-reviewable-form-textarea-min-h': this.textareaMinH >= 50 ? `${this.textareaMinH}px` : '132px',
      };
    },
  },

  mounted() {
    if (this.autofocus) {
      this.$refs.textarea?.focus();
    }
  },

  methods: {
    onClose() {
      this.text = '';
      this.$emit('close');
    },
    onSubmit() {
      this.$emit('submit', this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-reviewable-form {
  border: 1px solid vars.$c-gray-d8;

  .form-inner {
    display: flex;
    gap: 12px;
    padding: 16px 16px 0;
  }

  .review-textarea {
    width: 100%;
    min-height: var(--app-reviewable-form-textarea-min-h, 50px);
    max-height: 240px;
    resize: vertical;
    padding: 0;
    font-size: 16px;
    line-height: 1.5;
    border: none;
    background-color: vars.$c-total-white;

    @media (min-width: vars.$tablet-break-point + 1) {
      font-size: 18px;
    }
  }

  .btn-close {
    padding-right: 0;
  }

  .form-footer {
    padding: 12px 16px 8px;
    text-align: right;
  }

  .btn-submit {
    display: block;
    width: 100%;
    padding-top: 8px;
    padding-bottom: 8px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
    transition: all 0.2s;

    @media (min-width: vars.$tablet-break-point) {
      display: inline-block;
      width: max-content;
    }

    @media (min-width: vars.$tablet-break-point + 1) {
      font-size: 18px;
    }

    &:not([disabled]) {
      color: vars.$c-dark-gray;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
